import React from "react";
import {
  QuestionDropdownModel,
  QuestionFactory,
  Serializer,
  ItemValue,
} from "survey-core";
import {
  ReactQuestionFactory,
  SurveyQuestionElementBase,
} from "survey-react-ui";

const QUESTION_TYPE = "assignedDrugKit";
let isRegistered = false;

class QuestionAssignedDrugKitModel extends QuestionDropdownModel {
  constructor(name) {
    super(name);

    this.createNewArray("choices");
  }

  getType() {
    return QUESTION_TYPE;
  }

  get placeholder() {
    return this.getPropertyValue("placeholder", "Select Drug Kit");
  }

  set placeholder(val) {
    this.setPropertyValue("placeholder", val);
  }
}

class SurveyQuestionAssignedDrugKit extends SurveyQuestionElementBase {
  get question() {
    return this.props.question;
  }

  handleChange = (e) => {
    this.question.value = e.target.value || null;
  };

  renderElement() {
    const q = this.question;
    const value = q.value ?? "";

    return (
      <select
        value={value}
        onChange={this.handleChange}
        disabled={q.isReadOnly}
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: "6px 12px",
          borderRadius: "4px",
          border: "1px solid #ced4da",
          backgroundColor: "#fff",
        }}
      >
        <option value="">{q.placeholder}</option>

        {/* Use visibleChoices or choices based on availability */}
        {(q.visibleChoices || q.choices || []).map((choice) => (
          <option key={choice.value} value={choice.value}>
            {choice.text || choice.value}
          </option>
        ))}
      </select>
    );
  }
}

export function registerAssignedDrugKitQuestion() {
  if (isRegistered) return;
  isRegistered = true;

  Serializer.addClass(
    QUESTION_TYPE,
    [
      {
        name: "placeholder:text",
        category: "general",
        default: "Select Drug Kit",
      },
      {
        name: "name",
        type: "text",
        category: "general",
        visible: true,
        isRequired: true,
        isLocalizable: false,
        onSetValue: function (obj, value) {
          obj.setPropertyValue("name", value);
        },
        onGetValue: function (obj) {
          return obj.getPropertyValue("name");
        },
      },
    ],
    () => new QuestionAssignedDrugKitModel(""),
    "dropdown"
  );

  QuestionFactory.Instance.registerQuestion(
    QUESTION_TYPE,
    (name) => new QuestionAssignedDrugKitModel(name)
  );

  ReactQuestionFactory.Instance.registerQuestion(QUESTION_TYPE, (props) =>
    React.createElement(SurveyQuestionAssignedDrugKit, props)
  );
}

registerAssignedDrugKitQuestion();

export default QuestionAssignedDrugKitModel;
